var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.72rem",
    viewBox: "0 0 27.595 26.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header_Messaging",
    "data-name": "Header Messaging",
    transform: "translate(-2586.987 -40.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message_icon",
    "data-name": "message icon",
    transform: "translate(2588 41.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M23.127,1.026H4.442a3.4,3.4,0,0,0-2.43,1.038A3.586,3.586,0,0,0,1,4.558V16.67a3.589,3.589,0,0,0,1.011,2.5A3.407,3.407,0,0,0,4.442,20.2H6.9V25.25l5.761-4.93a.485.485,0,0,1,.316-.118H23.127a3.407,3.407,0,0,0,2.43-1.037,3.589,3.589,0,0,0,1.011-2.5V4.558a3.586,3.586,0,0,0-1.011-2.494,3.4,3.4,0,0,0-2.43-1.038Z",
    transform: "translate(-1 -1.026)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinejoin: "round",
    strokeWidth: 2.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M6.814,10.984A2.019,2.019,0,1,0,4.846,8.966,1.993,1.993,0,0,0,6.814,10.984Z",
    transform: "translate(0.071 0.622)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M11.428,10.984A2.019,2.019,0,1,0,9.462,8.966,1.992,1.992,0,0,0,11.428,10.984Z",
    transform: "translate(1.356 0.622)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M16.043,10.984a2.019,2.019,0,1,0-1.966-2.018A1.994,1.994,0,0,0,16.043,10.984Z",
    transform: "translate(2.641 0.622)",
    fill: "#199b8b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingIcon);
export default __webpack_public_path__ + "static/media/messaging-icon.ede8bfb62360b4c72df6a2c104050d0c.svg";
export { ForwardRef as ReactComponent };